import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';

import DateTime from '../../../DateTimePicker';
import { LabelName, Required } from '../../../../../utils';

export function DateTimeSelector({ data, setData, setError, ind, isRequired, globalStateData }) {
  const { needDate, needTime } = data.dateTimeValidation;
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');

  const isDisabled =
    globalStateData?.customFormData?.[ind]?.isEditable !== undefined
      ? !globalStateData?.customFormData?.[ind]?.isEditable
      : false;

  const handleChange = (setValue) => (e) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    const storedValue = globalStateData?.customFormData?.[ind]?.fieldValue || '';

    if (storedValue) {
      const dateMatch = storedValue.match(/^\d{4}-\d{2}-\d{2}/);
      const timeMatch = storedValue.match(/\d{2}:\d{2}/);

      if (dateMatch) setSelectedDate(dateMatch[0]);
      if (timeMatch) setSelectedTime(timeMatch[0]);
    }
  }, []);

  useEffect(() => {
    setError(null);

    if (isRequired && !selectedDate && !selectedTime) {
      setError(`Field ${ind + 1} is required.`);
      return;
    }

    let formattedTime = selectedTime;
    // if (selectedTime) {
    //   const [hours, minutes] = selectedTime.split(":");
    //   const formattedHours = (hours % 12 || 12).toString().padStart(2, "0");
    //   const period = hours >= 12 ? "PM" : "AM";
    //   formattedTime = `${formattedHours}:${minutes} ${period}`;
    // }

    const formattedValue = [selectedDate, formattedTime].filter(Boolean).join(' ');

    if (data[ind] !== formattedValue) {
      setData(formattedValue, ind);
    }
  }, [selectedDate, selectedTime]);

  return (
    <Grid container style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <Grid item>
        <LabelName>
          {data?.fieldName}
          {isRequired && <Required> *</Required>}
        </LabelName>
      </Grid>

      <Grid item container spacing={2}>
        {needDate && (
          <Grid item xs={6}>
            <DateTime
              //   helperText="Select Date"
              type="date"
              onChange={handleChange(setSelectedDate)}
              value={selectedDate}
              required={isRequired}
              disabled={isDisabled}
            />
          </Grid>
        )}
        {needTime && (
          <Grid item xs={6}>
            <DateTime
              //   helperText="Select time"
              type="time"
              onChange={handleChange(setSelectedTime)}
              value={selectedTime}
              required={isRequired}
              disabled={isDisabled}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}

export default DateTimeSelector;
